import { render } from "./Modal.vue?vue&type=template&id=2dc2d7a6"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
script.render = render

export default script